import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { ReactElement } from 'react';

type ProtectedRouteProps = {
  allowedRoles?: string[];
  element: ReactElement;
};

const ProtectedRoute = ({ allowedRoles, element: Element }: ProtectedRouteProps) => {
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const isAuthenticated =
    userDetails != null && Object.keys(userDetails).length > 0;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const allowAnyAuthenticatedRole =
    !allowedRoles ||
    allowedRoles.length === 0 ||
    (allowedRoles.length === 1 && allowedRoles[0] === '');

  if (!allowAnyAuthenticatedRole) {
    const userRole = String(userDetails.UserRole ?? '');
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return Element;
};

export default ProtectedRoute;
